// extracted by mini-css-extract-plugin
export default {"wrap":"Page_StylesAccess_wrap__geE2+","card":"Page_StylesAccess_card__CRokB","icon":"Page_StylesAccess_icon__h0jjk"};